import * as Yup from 'yup'

export const schema = (t: (key: string) => string) => ({
  action: Yup.string().required(t('requiredMessage')),
  cancellationReason: Yup.string().required(t('requiredMessage')),
  cancellationDescription: Yup.string().required(t('requiredMessage')),
})
